import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';

export function fetchAccessibleBidRequestIds (ids: string[]) {
  const query = ids.map(id => `ids[]=${id}`).join('&');
  return Call('get', ApiUrl(`/overview/bid_requests/accessible_ids?${query}`), {}, ParseGeneralResponse, {
    responseDataKeys: { accessibleIds: 'accessible_ids' },
  });
}
